import styled from 'styled-components';

const Header = styled.div`
  font-family: 'CircularStd-Bold';
  font-size: 25px;
`;

export default Header;
